/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimitexceedederror3Inputs */

const en_ratelimitexceedederror3 = /** @type {(inputs: Ratelimitexceedederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many requests. Please try again later.`)
};

const de_ratelimitexceedederror3 = /** @type {(inputs: Ratelimitexceedederror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Anfragen. Versuch's gleich nochmal.`)
};

/**
* | output |
* | --- |
* | "Too many requests. Please try again later." |
*
* @param {Ratelimitexceedederror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ratelimitexceedederror3 = /** @type {((inputs?: Ratelimitexceedederror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimitexceedederror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ratelimitexceedederror3(inputs)
	return de_ratelimitexceedederror3(inputs)
});
export { ratelimitexceedederror3 as "rateLimitExceededError" }